import { useCallback, useEffect, useState } from 'react';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { ICorpResponse } from 'src/types/Corp';
import { getCorpData } from 'src/common/features/Corp/functions/getCorpData';

export type UseGetCorpDataReturn = {
  data?: ICorpResponse;
  isLoading?: boolean;
};

export const useGetCorpData = (corpId: string): UseGetCorpDataReturn => {
  const [isLoading, setIsLoading] = useState<boolean>();
  const [data, setData] = useState<ICorpResponse>();

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const responseData = await getCorpData(corpId);

      setData(responseData);
    } catch (error) {
      pushErrorFromAPI(error);
    } finally {
      setIsLoading(false);
    }
  }, [corpId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    isLoading,
  };
};
